/**
 *
 * MenuItemStatic
 *
 */

import React, { memo } from 'react';

import { StyledMenuItemStatic } from './Menu.styles';

function MenuItemStatic({ ...props }) {
  return <StyledMenuItemStatic {...props} />;
}

export default memo(MenuItemStatic);
